// helpers
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';

export const DEFAULT_VIDEO_CONFIG = {
  position: 2,
  loop: true,
  muted: true,
};

// defs
interface IVideo {
  length: number;
  watchDuration: number;
  videoId: string;
  videoIndex: number;
  interactions: string[];
}

interface IVideosWatched {
  [key: string]: IVideo;
}

let defaultVideosWatched = {
  length: 0,
  watchDuration: 0,
  videoId: '',
  videoIndex: 0,
  interactions: [],
};

let videosWatched: IVideosWatched = {};

// add videoplayer interactions in interaction array, like, play, pause, mute, unmute and fullscreen
export const addInteractions = (videoId: string, interaction: string) => {
  if (videosWatched[videoId] == undefined) {
    videosWatched[videoId] = defaultVideosWatched;
  }

  const interactions = videosWatched[videoId].interactions;

  if (!interactions.includes(interaction)) {
    interactions.push(interaction);
  }
};

// update duration of video watched
export const updateWatchDuration = (videoId: string, duration: number) => {
  if (!videosWatched[videoId]) {
    return;
  }
  if (videosWatched[videoId].watchDuration < duration) {
    videosWatched[videoId].watchDuration = duration;
  }
};

// set the video length
export const setLength = (videoIndex: number, videoId: string, len: number) => {
  if (videosWatched[videoId] == undefined) {
    videosWatched[videoId] = { ...defaultVideosWatched };
  }
  videosWatched[videoId].videoId = videoId;
  videosWatched[videoId].length = len;
  videosWatched[videoId].videoIndex = videoIndex;
};

// when video is ended, setting video watched duration to video length
export const videoEnded = (videoId: string) => {
  videosWatched[videoId].watchDuration = videosWatched[videoId].length;
};

// storing videos in local storage
export const storeWatchedVideosLocally = () => {
  let videos = videosWatched;

  for (const key of Object.keys(videos)) {
    if (videos[key].watchDuration < 2) {
      delete videos[key];
    }
  }

  if (Object.keys(videos).length > 0) {
    storeAnalyticsDataInLocal({ videos: videos });
    videosWatched = {};
  }
};
